import React, {useEffect, useState} from 'react';
import './style.scss';
import Slider from 'react-slick';
import {loadSlickCSS} from '../../shared/helpers';
import AwNextArrow from './AwNextArrow';
import AwPrevArrow from './AwPrevArrow';
import arrow from '../../assets/images/hero-arrow.png';

const SliderWrap = (props) => {
    const [arrowVisible, setArrowVisible] = useState(true);
    useEffect(() => {
        loadSlickCSS()
        console.log('children ',props.children);
    },[props.children]);

    const settings = {
        dots: false,
        infinite: true,
        centerPadding: "80px",
        slidesToShow: 4,
        speed: 500,
        slidesToScroll: 1,
        nextArrow: <AwNextArrow />,
        prevArrow: <AwPrevArrow />,
        afterChange: () =>
            setArrowVisible(false),
        responsive: [
            {
                breakpoint:1600,
                settings: {
                    className: "center",
                    // variableWidth: true,
                    swipeToSlide: true,
                    centerMode: false,
                    infinite: true,
                    centerPadding: "80px",
                    slidesToShow: 4,
                    dots: false,
                    speed: 500,
                    nextArrow: <AwNextArrow/>,
                    prevArrow: <AwPrevArrow/>,
                }
            },
            {
                breakpoint:1268,
                settings: {
                    className: "center",
                    // variableWidth: true,
                    swipeToSlide: true,
                    centerMode: false,
                    infinite: true,
                    centerPadding: "40px",
                    slidesToShow: 3,
                    dots: false,
                    speed: 500,
                    nextArrow: <AwNextArrow/>,
                    prevArrow: <AwPrevArrow/>,
                }
            },
            {
                breakpoint:850,
                settings: {
                    className: "center",
                    // variableWidth: true,
                    swipeToSlide: true,
                    centerMode: true,
                    infinite: true,
                    centerPadding: "200px",
                    slidesToShow: 1,
                    dots:false,
                    speed: 500,
                    arrows:false
                }
            },
            {
                breakpoint:728,
                settings: {
                    className: "center",
                    variableWidth: true,
                    swipeToSlide: true,
                    centerMode: false,
                    infinite: true,
                    centerPadding: "100px",
                    slidesToShow: 1,
                    dots:false,
                    speed: 500,
                    arrows:false
                }
            },
            {
                breakpoint:500,
                settings: {
                    className: "center",
                    //  variableWidth:true,
                    swipeToSlide: true,
                    centerMode: true,
                    infinite: true,
                    centerPadding: "40px",
                    slidesToShow: 1,
                    dots:false,
                    speed: 500,
                    arrows:false
                }
            }
        ]
    };

    return (
        <div className="slider-wrap">
            <Slider {...settings}>  
               {props.children}
            </Slider>
            {!props.isDesktop && <span className="bounce-wrap"><img src={arrow} alt="arrow" className={`arrow side-bounce ${arrowVisible ? '' : 'hide'}`}/></span>
            }
        </div>

    )
}
export default SliderWrap;